export default function (point) {
  return {
    x: [point[0], point[0]],
    y: [point[1], point[1]]
  }
}
